import { HeatMapZone } from 'logic/reports/HeatMapZone';
import { DrawData } from 'ui/shared/calculateDrawData';

export const consts = {
    fontSize: 15, // pixels
    dragHandleSize: 9,
    xNameOffset: 4,
    yNameOffset: 4,
    xNamePadding: 5,
    yNamePadding: 3,
};

export const drawZonesOnCanvas = (
    canvas: HTMLCanvasElement | null,
    drawData: DrawData,
    backgroundImage: HTMLImageElement | null,
    zones: ReadonlyArray<HeatMapZone>,
    selectedZoneName: string | null,
) => {
    if (!canvas) {
        return;
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error('Failed to get 2d context');
    }
    ctx.save();

    ctx.font = `${consts.fontSize}px Arial`;
    ctx.strokeStyle = 'transparent';

    // TODO: double buffering

    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.translate(drawData.xOffset, drawData.yOffset);

    // Draw the background image scaled and centered on the canvas
    if (backgroundImage) {
        ctx.drawImage(backgroundImage, 0, 0, drawData.width, drawData.height);
    }

    ctx.scale(drawData.scale, drawData.scale);

    // Draw the zones on the canvas
    zones.forEach((z, i) => {
        const [ topLeft, topRight, bottomLeft, bottomRight ] = z.points;

        // Draw the zone boundary lines
        ctx.beginPath();
        ctx.moveTo(topLeft.x, topLeft.y);
        ctx.lineTo(topRight.x, topRight.y);
        ctx.lineTo(bottomRight.x, bottomRight.y);
        ctx.lineTo(bottomLeft.x, bottomLeft.y);
        ctx.closePath();
        ctx.strokeStyle = 'rgba(0,0,0,.5)';
        ctx.lineWidth = 3;
        ctx.stroke();
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 1;
        ctx.stroke();
        
        // Draw the zone name
        const nameSize = ctx.measureText(z.name);
        ctx.fillStyle = 'rgba(0,0,0,.75)';
        ctx.fillRect(topLeft.x + consts.xNameOffset, topLeft.y + consts.yNameOffset, nameSize.width + consts.xNamePadding * 2, consts.fontSize + consts.yNamePadding * 2); // tslint:disable-line
        ctx.fillStyle = '#fff';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
        ctx.fillText(z.name, topLeft.x + consts.xNameOffset + consts.xNamePadding, topLeft.y + consts.yNameOffset + consts.yNamePadding - 1);

        // Draw the four corner drag handles
        let offset = (consts.dragHandleSize - 1) / 2;
        ctx.fillStyle = 'rgba(0,0,0,.5)';
        ctx.fillRect(topLeft.x - offset, topLeft.y - offset, consts.dragHandleSize, consts.dragHandleSize);
        ctx.fillRect(topRight.x - offset, topRight.y - offset, consts.dragHandleSize, consts.dragHandleSize);
        ctx.fillRect(bottomLeft.x - offset, bottomLeft.y - offset, consts.dragHandleSize, consts.dragHandleSize);
        ctx.fillRect(bottomRight.x - offset, bottomRight.y - offset, consts.dragHandleSize, consts.dragHandleSize);
        offset = (consts.dragHandleSize - 3) / 2;
        ctx.fillStyle = '#fff';
        ctx.fillRect(topLeft.x - offset, topLeft.y - offset, consts.dragHandleSize - 2, consts.dragHandleSize - 2);
        ctx.fillRect(topRight.x - offset, topRight.y - offset, consts.dragHandleSize - 2, consts.dragHandleSize - 2);
        ctx.fillRect(bottomLeft.x - offset, bottomLeft.y - offset, consts.dragHandleSize - 2, consts.dragHandleSize - 2);
        ctx.fillRect(bottomRight.x - offset, bottomRight.y - offset, consts.dragHandleSize - 2, consts.dragHandleSize - 2);
        if (z.name !== selectedZoneName) {
            offset = (consts.dragHandleSize - 5) / 2;
            ctx.fillStyle = '#000';
            ctx.fillRect(topLeft.x - offset, topLeft.y - offset, consts.dragHandleSize - 4, consts.dragHandleSize - 4);
            ctx.fillRect(topRight.x - offset, topRight.y - offset, consts.dragHandleSize - 4, consts.dragHandleSize - 4);
            ctx.fillRect(bottomLeft.x - offset, bottomLeft.y - offset, consts.dragHandleSize - 4, consts.dragHandleSize - 4);
            ctx.fillRect(bottomRight.x - offset, bottomRight.y - offset, consts.dragHandleSize - 4, consts.dragHandleSize - 4);
        }
    });

    ctx.restore();
};



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/zoneSelection/drawZonesOnCanvas.ts